import { PITCH_DIMENSIONS, VISUALIZATION_LAYOUT } from "@Components/game/session-results/feedback/visualization/constants";

interface LoadingFormationPlayer {
  id: string;
  left: number;
  top: number;
  team: 0 | 1;
  jerseyNumber: number;
}

const LOADING_FORMATION_PLAYERS: LoadingFormationPlayer[] = [
  { id: "a-gk", left: 4, top: 50, team: 0, jerseyNumber: 1 },
  { id: "a-lb", left: 20, top: 12, team: 0, jerseyNumber: 3 },
  { id: "a-lcb", left: 18, top: 37, team: 0, jerseyNumber: 5 },
  { id: "a-rcb", left: 18, top: 63, team: 0, jerseyNumber: 4 },
  { id: "a-rb", left: 20, top: 88, team: 0, jerseyNumber: 2 },
  { id: "a-dm", left: 28, top: 50, team: 0, jerseyNumber: 6 },
  { id: "a-cm-1", left: 33, top: 30, team: 0, jerseyNumber: 8 },
  { id: "a-cm-2", left: 33, top: 70, team: 0, jerseyNumber: 10 },
  { id: "a-lw", left: 43, top: 16, team: 0, jerseyNumber: 11 },
  { id: "a-st", left: 46, top: 50, team: 0, jerseyNumber: 9 },
  { id: "a-rw", left: 43, top: 84, team: 0, jerseyNumber: 7 },
  { id: "b-gk", left: 96, top: 50, team: 1, jerseyNumber: 1 },
  { id: "b-lb", left: 80, top: 12, team: 1, jerseyNumber: 3 },
  { id: "b-lcb", left: 82, top: 37, team: 1, jerseyNumber: 5 },
  { id: "b-rcb", left: 82, top: 63, team: 1, jerseyNumber: 4 },
  { id: "b-rb", left: 80, top: 88, team: 1, jerseyNumber: 2 },
  { id: "b-dm", left: 72, top: 50, team: 1, jerseyNumber: 6 },
  { id: "b-cm-1", left: 67, top: 30, team: 1, jerseyNumber: 8 },
  { id: "b-cm-2", left: 67, top: 70, team: 1, jerseyNumber: 10 },
  { id: "b-lw", left: 57, top: 16, team: 1, jerseyNumber: 11 },
  { id: "b-st", left: 54, top: 50, team: 1, jerseyNumber: 9 },
  { id: "b-rw", left: 57, top: 84, team: 1, jerseyNumber: 7 },
];

const buildLoadingPlayers = () =>
  LOADING_FORMATION_PLAYERS.map(player => {
    const stageX = VISUALIZATION_LAYOUT.pitch.x + (PITCH_DIMENSIONS.WIDTH * player.left) / 100;
    const stageY = VISUALIZATION_LAYOUT.pitch.y + (PITCH_DIMENSIONS.HEIGHT * player.top) / 100;

    return {
      id: player.id,
      team: player.team,
      jerseyNumber: player.jerseyNumber,
      isPlayer: false,
      x: stageX - VISUALIZATION_LAYOUT.playerLayerOrigin.x,
      y: stageY - VISUALIZATION_LAYOUT.playerLayerOrigin.y,
    };
  });

export default buildLoadingPlayers;
